.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  &:not(:last-child) {
    padding-bottom: 1.2rem;
    border-bottom: 1px solid var(--color-grayscale-arsenic);
  }
}

.title {
  font-weight: 700;
  font-size: 1.4rem;
}

.properties {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.property {
  display: flex;
  flex-direction: row;
  height: 2.4rem;
}

.label {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 8.6rem;
}

.action {
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
}
